window.addEventListener('load',()=>{
	/* Switch login */
	/* -------------------------------------------------------------------------------------- */
	$('[js-open-recover]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this).attr('href');
		$(el).addClass('active');
		$('#login').removeClass('active');
	});

	$('[js-close-recover]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this).attr('href');
		$(el).removeClass('active');
		$('#recover').removeClass('active');
	});
	/* Show recover [GET] */
	/* -------------------------------------------------------------------------------------- */
	function searchRecover(url) {
		var regex = new RegExp("\W*recover\W*");
			results = regex.exec(url);
		return results === null ? "" : results;
	}

	var url = window.location.href;
	recover = searchRecover(url);
	if (recover != "") {
		$('#recover').addClass('active');
		$('#login').removeClass('active');
	}
});